<div class="modal-header">
  <h4 class="modal-title">Ajout/Edition de vos informations de contact</h4>
</div>
<div class="modal-body">
  <div class="container">
    <div class="form-group row" [formGroup]="pickupOwnerForm">
      <div class="col-12">
        <div class="row justify-content-center" *ngIf="!pickupOwner">
          <div class="col-10">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="advertising" formControlName="advertisingEnabled">
              <label class="form-check-label" for="advertising">
                <strong>ARS UNIQUEMENT (<u>sauf Fi</u>) :</strong> Envoyez-moi de la PLV (uniquement pour le premier lot de kits)
              </label>
            </div>
            <div *ngIf="isPickupMode && pickupOwnerForm.value.advertisingEnabled" class="mt-3">
              <div *ngFor="let opt of colorOptions" class="form-check mb-2">
                <input class="form-check-input" type="radio" formControlName="advertisingColor" [value]="opt.value" [id]="opt.value">
                <label class="form-check-label" [for]="opt.value">
                  <strong>{{ opt.label }}</strong> — {{ opt.desc }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10">
            <label for="lastName" class="sr-only">Nom</label>
            <input type="text" class="form-control mb-3" id="lastName" formControlName="lastName">
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10">
            <label for="firstName" class="sr-only">Prénom</label>
            <input type="text" class="form-control mb-3" id="firstName" formControlName="firstName">
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10">
            <label for="email" class="sr-only">Email</label>
            <input type="email" class="form-control mb-3" id="email" formControlName="email">
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-10">
            <label for="phoneNumber" class="sr-only">Téléphone</label>
            <input type="tel" class="form-control mb-3" id="phoneNumber" formControlName="phoneNumber"
                   [maskito]="phoneMask">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer justify-content-center">
  <button type="button" class="btn btn-primary"
          [disabled]="!pickupOwnerForm.valid"
          (click)="onValidate()">
    Valider
  </button>
</div>
